<template>
<div class="chapter">
<div class="inner_page">
<div class="copyright" id="cop">
<p class="crt">Publication of this volume was made possible in part by a grant from the National Endowment for the Humanities.</p>
<p class="crt">Copyright © 2007 by The University Press of Kentucky</p>
<p class="crt">Scholarly publisher for the Commonwealth, serving Bellarmine University, Berea College, Centre College of Kentucky, Eastern Kentucky University, The Filson Historical Society, Georgetown College, Kentucky Historical Society, Kentucky State University, Morehead State University, Murray State University, Northern Kentucky University, Transylvania University, University of Kentucky, University of Louisville, and Western Kentucky University.<br/>All rights reserved.</p>
<p class="crt"><em>Editorial and Sales Offices:</em> The University Press of Kentucky<br/>663 South Limestone Street, Lexington, Kentucky 40508-4008<br/><a class="hlink" href="http://www.kentuckypress.com" target="_blank">www.kentuckypress.com</a></p>
<p class="crt">11 10 09 08 07    5 4 3 2 1</p>
<p class="crt">Library of Congress Cataloging-in-Publication Data</p>
<p class="crt">The philosophy of neo-noir / edited by Mark T. Conard.</p>
<p class="crt1">     p. cm.—(The philosophy of popular culture)</p>
<p class="crt1">Includes bibliographical references and index.</p>
<p class="crt1">ISBN-13: 978-0-8131-2422-3 (hardcover: alk. paper)</p>
<p class="crt1">ISBN-10: 0-8131-2422-0 (hardcover: alk. paper)</p>
<p class="crt1">1. Film noir—United States—History and criticism.<br/>I. Conard, Mark T., 1965-</p>
<p class="crt1">PN1995.9.F54P56 2006</p>
<p class="crt1">791.43’6556—dc22</p>
<p class="crt1">2006032084</p>
<p class="crt">This book is printed on acid-free recycled paper meeting the requirements of the American National Standard for Permanence in Paper for Printed Library Materials.</p>
<p class="crt"><img alt="" src="OEBPS/images/logo3.png"/></p>
<p class="crt">Manufactured in the United States of America.</p>
<p class="crt"><img alt="" class="middle" src="OEBPS/images/logo4.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780813172309_epub_cop_r1.vue?3a6d27e8